<template>

    <section
        class="c-event_form">
        <form @submit.prevent="saveEvent('event-form')" data-vv-scope="event-form" class="c-event_form__form">
            <h2 class="c-event_form__title">
                Planowana wizyta dla:
                <span class="c-event_form__title-patient">{{ patient.first_name }} {{ patient.last_name }}</span>
            </h2>
            <form-row>
                <form-date
                    v-model="date"
                    type="date"
                    label="Data wizyty"
                    data-vv-as="Data wizyty"
                    @input="compTimes"
                    v-validate="'required'">
                </form-date>
                <form-inline>
                    <form-date
                        v-model="value.start"
                        type="time"
                        label="Od godziny"
                        @input="calcDates"
                        :min-datetime="startTime"
                        data-vv-as="Godzina od"
                        v-validate="'required'">
                    </form-date>
                    <form-date
                        v-model="value.end"
                        type="time"
                        label="Do godziny"
                        data-vv-as="Godzina do"
                        @input="calcDates"
                        :min-datetime="value.start"
                        v-validate="'required'">
                    </form-date>
                </form-inline>
            </form-row>
            <form-row>
                <form-switch
                    v-model="value.type"
                    false-value="office"
                    true-value="mobile"
                    label="Wizyta domowa">
                </form-switch>
                <form-switch
                    v-model="value.type"
                    false-value="mobile"
                    true-value="office"
                    label="Wizyta w gabinecie">
                </form-switch>
            </form-row>

            <form-row v-if="value.type === 'office'">
                <form-select
                    v-model="value.office_id"
                    :options="phtOffices"
                    label="Placówka"
                    data-vv-as="Placówka"
                    v-validate="'required'">
                </form-select>
            </form-row>

            <form-row v-else>
                <form-input
                    v-model="value.mobile_street"
                    label="Ulica i numer domu"
                    speech-to-text>
                </form-input>
                <form-input
                    v-model="value.mobile_city"
                    label="Miejscowość"
                    speech-to-text>
                </form-input>
            </form-row>
            <form-row align="between">
                <v-btn
                    type="green"
                    role="submit"
                    has-loader
                    :loading="isLoading">
                    Zapisz
                </v-btn>
            </form-row>
        </form>
    </section>

</template>


<script>

import moment from 'moment'
import {mapGetters} from 'vuex'
import {FormRow, FormInline, FormInput, FormDate, FormSwitch, FormSelect} from 'Components/Form'

import VBtn from 'Components/VBtn'

export default {

    name: 'EventForm',

    props: {
        value: Object,
        mode: String
    },

    data() {
        return {
            today: '',
            date: '',
            isLoading: false
        }
    },

    computed: {
        ...mapGetters(['phtOffices', 'patient']),
        nowDate() {
            var date = moment()
            var roundedDate = this.roundTime(date, moment.duration(5, "minutes"), "floor")
            return moment(roundedDate).format()
        },
        startTime() {
            return moment(this.date).hours(6).minutes(0).format()
        },
    },

    methods: {
        saveEvent(scope) {
            this.isLoading = true
            this.$validator.validateAll(scope).then((isValid) => {
                if (isValid) {
                    var _event = {
                        patient_id: this.patient.id,
                        start: moment(this.value.start).format('YYYY-MM-DD HH:mm:ss'),
                        end: moment(this.value.end).format('YYYY-MM-DD HH:mm:ss'),
                        type: this.value.type
                    }
                    if (this.value.type === 'office') {
                        _event.office_id = this.value.office_id
                    } else if (this.value.type === 'mobile') {
                        _event.mobile_street = this.value.mobile_street
                        _event.mobile_city = this.value.mobile_city
                    }
                    this.$emit('submit', _event, this.afterSubmit)
                } else {
                    this.isLoading = false
                }
            })
        },
        calcDates() {
            if (moment(this.value.end).diff(this.value.start, 'minutes') <= 0) {
                this.value.end = moment(this.value.start).add(1, 'hours').format()
                if (moment(this.value.end).day() > moment(this.value.start).day())
                    this.value.end = moment(this.date).hours(23).minutes(55).format()
            }
        },
        compTimes() {
            this.value.start = moment(this.date).format().split('T')[0] + 'T' + moment(this.value.start).format().split('T')[1]
            this.value.end = moment(this.date).format().split('T')[0] + 'T' + moment(this.value.end).format().split('T')[1]
        },
        roundTime(date, duration, method) {
            return moment(Math[method]((+date) / (+duration)) * (+duration));
        },
        afterSubmit() {
            this.isLoading = false
        }
    },

    mounted() {
        if (this.mode === 'new') {
            this.date = this.nowDate
            this.value.start = this.nowDate
            this.value.end = moment(this.nowDate).add(1, 'hours').format()
            this.value.mobile_street = this.patient.address_street
            this.value.mobile_city = this.patient.address_city
            this.value.type = 'mobile'
            this.value.office_id = null
            this.$validator.reset()
        } else {
            this.date = this.value.start
        }
    },

    components: {
        FormRow,
        FormInline,
        FormInput,
        FormDate,
        FormSwitch,
        FormSelect,
        VBtn
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-event_form {
    &__title {
        &-patient {
            color: $c-secondary;
        }
    }
    &__form {
        max-width: 450px;
    }
}

</style>
